export const FS_REGULAR = "400";
export const FS_SEMIBOLD = "500";
export const FS_BOLD = "600";
